import { render } from "./TopNavigation.vue?vue&type=template&id=f7be6ba4&scoped=true"
import script from "./TopNavigation.vue?vue&type=script&lang=js"
export * from "./TopNavigation.vue?vue&type=script&lang=js"

import "./TopNavigation.vue?vue&type=style&index=0&id=f7be6ba4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f7be6ba4"

export default script